export const FETCH_PERMISSIONS_REQUEST = "FETCH_PERMISSIONS_REQUEST";
export const FETCH_PERMISSIONS_SUCCESS = "FETCH_PERMISSIONS_SUCCESS";
export const FETCH_PERMISSIONS_FAILURE = "FETCH_PERMISSIONS_FAILURE";
